import { useState, useEffect } from 'react';
import scholarshipData from '../scholarships';

const scholarships = [
  { id:'cheveningScholarship',                 flag:'🇬🇧', name:'Chevening Scholarship',       country:'United Kingdom',    color:'#4f46e5' },
  { id:'daadScholarship',                      flag:'🇩🇪', name:'DAAD Scholarship',             country:'Germany',           color:'#0891b2' },
  { id:'fulbrightScholarship',                 flag:'🇺🇸', name:'Fulbright Scholarship',        country:'United States',     color:'#dc2626' },
  { id:'australiaAwardsScholarship',           flag:'🇦🇺', name:'Australia Awards',             country:'Australia',         color:'#d97706' },
  { id:'erasmusScholarship',                   flag:'🇪🇺', name:'Erasmus Mundus',               country:'Europe',            color:'#059669' },
  { id:'cscScholarship',                       flag:'🇨🇳', name:'CSC Scholarship',              country:'China',             color:'#dc2626' },
  { id:'swedishInstituteScholarship',          flag:'🇸🇪', name:'Swedish Institute',            country:'Sweden',            color:'#0891b2' },
  { id:'commonwealthScholarship',              flag:'🇬🇧', name:'Commonwealth Scholarship',     country:'UK & Commonwealth', color:'#7c3aed' },
  { id:'turkiyeBurslariScholarship',           flag:'🇹🇷', name:'Türkiye Burslari',             country:'Turkey',            color:'#dc2626' },
  { id:'gatesCambridgeScholarship',            flag:'🇬🇧', name:'Gates Cambridge',              country:'United Kingdom',    color:'#0284c7' },
  { id:'kaustScholarship',                     flag:'🇸🇦', name:'KAUST Scholarship',            country:'Saudi Arabia',      color:'#059669' },
  { id:'knightHennessyScholarship',            flag:'🇺🇸', name:'Knight-Hennessy',              country:'United States',     color:'#7c3aed' },
  { id:'mextScholarship',                      flag:'🇯🇵', name:'MEXT Scholarship',             country:'Japan',             color:'#dc2626' },
  { id:'rhodesScholarship',                    flag:'🇬🇧', name:'Rhodes Scholarship',           country:'United Kingdom',    color:'#0891b2' },
  { id:'swissGovernmentExcellenceScholarship', flag:'🇨🇭', name:'Swiss Government Excellence', country:'Switzerland',       color:'#dc2626' },
  { id:'stipendiumHungaricumScholarship',      flag:'🇭🇺', name:'Stipendium Hungaricum',        country:'Hungary',           color:'#059669' },
];

const TAG_COLORS = [
  { bg:'rgba(99,102,241,0.15)',  color:'#a5b4fc', border:'rgba(99,102,241,0.35)'  },
  { bg:'rgba(16,185,129,0.15)', color:'#6ee7b7', border:'rgba(16,185,129,0.35)'  },
  { bg:'rgba(245,158,11,0.15)', color:'#fcd34d', border:'rgba(245,158,11,0.35)'  },
  { bg:'rgba(239,68,68,0.15)',  color:'#fca5a5', border:'rgba(239,68,68,0.35)'   },
];

const globalStyle = `
  <style>
    .gc p      { margin-bottom:12px; color:#cbd5e1; font-size:15px; line-height:1.85; }
    .gc ul     { padding-left:22px; margin:10px 0 14px; }
    .gc ol     { padding-left:22px; margin:10px 0 14px; }
    .gc ul li  { margin-bottom:8px; color:#cbd5e1; line-height:1.7; font-size:15px; }
    .gc ol li  { margin-bottom:8px; color:#cbd5e1; line-height:1.7; font-size:15px; }
    .gc strong { color:#e2e8f0; font-weight:600; }
    .gc h4     { color:#a5b4fc; margin:16px 0 8px; font-size:15px; font-weight:700; }
  </style>
`;

export default function ScholarshipGuidePage({ setActivePage }) {
  const [selected,  setSelected]  = useState('cheveningScholarship');
  const [search,    setSearch]    = useState('');
  const [openIndex, setOpenIndex] = useState(0);
  const [guide,     setGuide]     = useState(null);
  const [loading,   setLoading]   = useState(false);

  const filtered    = scholarships.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.country.toLowerCase().includes(search.toLowerCase())
  );
  const currentMeta = scholarships.find(s => s.id === selected);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setGuide(null);
      try {
        const module = await scholarshipData[selected]();
        setGuide(module.default);
      } catch(err) {
        console.error('Guide load error:', err);
      }
      setLoading(false);
    };
    load();
  }, [selected]);

  const toggle       = (i)  => setOpenIndex(openIndex === i ? null : i);
  const handleSelect = (id) => { setSelected(id); setOpenIndex(0); };

  return (
    <div style={{display:'flex',minHeight:'calc(100vh - 68px)',background:'#060b14'}}>

      {/* ── SIDEBAR ── */}
      <div style={{width:'240px',background:'#080f1a',borderRight:'1px solid rgba(255,255,255,0.07)',display:'flex',flexDirection:'column',flexShrink:0,position:'sticky',top:'68px',height:'calc(100vh - 68px)'}}>

        <div style={{padding:'14px 14px 10px',borderBottom:'1px solid rgba(255,255,255,0.06)',flexShrink:0}}>
          <p style={{fontFamily:'Inter,sans-serif',fontSize:'10px',fontWeight:'700',color:'#475569',textTransform:'uppercase',letterSpacing:'1.5px',margin:'0 0 10px'}}>
            TOP SCHOLARSHIPS
          </p>
          <div style={{position:'relative'}}>
            <span style={{position:'absolute',left:'10px',top:'50%',transform:'translateY(-50%)',fontSize:'12px',color:'#475569',pointerEvents:'none'}}>🔍</span>
            <input
              placeholder="Search scholarship..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{width:'100%',padding:'8px 8px 8px 28px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'9px',color:'#e2e8f0',fontFamily:'Inter,sans-serif',fontSize:'12px',outline:'none',boxSizing:'border-box'}}
              onFocus={e => e.target.style.borderColor='rgba(99,102,241,0.5)'}
              onBlur={e  => e.target.style.borderColor='rgba(255,255,255,0.1)'}
            />
          </div>
        </div>

        <div style={{overflowY:'auto',flex:1,padding:'6px 0'}}>
          {filtered.map(s => {
            const isActive = selected === s.id;
            return (
              <div
                key={s.id}
                onClick={() => handleSelect(s.id)}
                style={{padding:'9px 12px',cursor:'pointer',background:isActive?'rgba(99,102,241,0.15)':'transparent',borderLeft:isActive?`3px solid ${s.color}`:'3px solid transparent',transition:'all 0.15s',marginBottom:'1px'}}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background='rgba(255,255,255,0.04)'; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.background='transparent'; }}
              >
                <div style={{display:'flex',alignItems:'center',gap:'9px',marginBottom:'2px'}}>
                  <div style={{width:'28px',height:'28px',borderRadius:'8px',background:isActive?s.color:'rgba(255,255,255,0.06)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',flexShrink:0,transition:'all 0.15s',border:isActive?'none':'1px solid rgba(255,255,255,0.08)'}}>
                    {s.flag}
                  </div>
                  <span style={{fontFamily:'Inter,sans-serif',fontSize:'12px',color:isActive?'#ffffff':'#cbd5e1',fontWeight:isActive?'700':'400',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>
                    {s.name}
                  </span>
                </div>
                <div style={{fontFamily:'Inter,sans-serif',fontSize:'10px',color:isActive?'#94a3b8':'#475569',paddingLeft:'37px'}}>
                  {s.country}
                </div>
              </div>
            );
          })}
        </div>

        <div style={{padding:'10px 14px',borderTop:'1px solid rgba(255,255,255,0.06)',flexShrink:0,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <span style={{fontFamily:'Inter,sans-serif',fontSize:'11px',color:'#334155'}}>{filtered.length} scholarships</span>
          <span style={{fontFamily:'Inter,sans-serif',fontSize:'10px',color:'#10b981',fontWeight:'600'}}>● All Fully Funded</span>
        </div>
      </div>

      {/* ── RIGHT CONTENT ── */}
      <div style={{flex:1,overflowY:'auto'}}>

        {(loading || !guide) && (
          <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%',flexDirection:'column',gap:'12px',minHeight:'400px'}}>
            <div style={{width:'32px',height:'32px',border:`3px solid ${currentMeta?.color||'#6366f1'}44`,borderTop:`3px solid ${currentMeta?.color||'#6366f1'}`,borderRadius:'50%',animation:'spin 0.8s linear infinite'}} />
            <style>{`@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}`}</style>
            <span style={{fontFamily:'Inter,sans-serif',fontSize:'14px',color:'#475569'}}>Loading {currentMeta?.name}...</span>
          </div>
        )}

        {!loading && guide && (
          <div style={{padding:'32px 44px'}}>

            {/* Header */}
            <div style={{marginBottom:'28px',paddingBottom:'24px',borderBottom:'1px solid rgba(255,255,255,0.07)'}}>
              <div style={{display:'flex',alignItems:'flex-start',gap:'16px',marginBottom:'16px'}}>
                <div style={{width:'56px',height:'56px',borderRadius:'14px',background:`linear-gradient(135deg, ${currentMeta?.color||'#6366f1'}33, ${currentMeta?.color||'#6366f1'}66)`,border:`1px solid ${currentMeta?.color||'#6366f1'}44`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'28px',flexShrink:0}}>
                  {guide.flag}
                </div>
                <div style={{flex:1}}>
                  <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'6px',flexWrap:'wrap'}}>
                    <h1 style={{fontFamily:'Space Grotesk,sans-serif',fontSize:'24px',fontWeight:'700',color:'#f1f5f9',margin:0,letterSpacing:'-0.5px'}}>
                      {guide.name}
                    </h1>
                    <span style={{fontFamily:'Inter,sans-serif',fontSize:'11px',fontWeight:'700',background:'rgba(16,185,129,0.15)',color:'#10b981',padding:'3px 10px',borderRadius:'20px',border:'1px solid rgba(16,185,129,0.3)',whiteSpace:'nowrap'}}>
                      ✓ Fully Funded
                    </span>
                  </div>
                  <p style={{fontFamily:'Inter,sans-serif',fontSize:'13px',color:'#64748b',margin:0,lineHeight:1.6}}>
                    {guide.tagline}
                  </p>
                </div>
              </div>
              <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                {['Fully Funded','Requirements','How to Apply','Tips to Win'].map((tag,i) => (
                  <span key={tag} style={{fontFamily:'Inter,sans-serif',fontSize:'11px',fontWeight:'600',background:TAG_COLORS[i].bg,color:TAG_COLORS[i].color,border:`1px solid ${TAG_COLORS[i].border}`,padding:'4px 12px',borderRadius:'20px'}}>
                    {tag}
                  </span>
                ))}
                <span style={{fontFamily:'Inter,sans-serif',fontSize:'11px',fontWeight:'600',background:'rgba(255,255,255,0.05)',color:'#94a3b8',border:'1px solid rgba(255,255,255,0.1)',padding:'4px 12px',borderRadius:'20px'}}>
                  🌍 {currentMeta?.country}
                </span>
              </div>
            </div>

            {/* Accordion */}
            <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
              {guide.sections.map((sec, i) => {
                const isOpen = openIndex === i;
                const color  = currentMeta?.color || '#6366f1';
                return (
                  <div key={i} style={{background:isOpen?'#111827':'rgba(255,255,255,0.02)',borderRadius:'12px',border:`1px solid ${isOpen?color:'rgba(255,255,255,0.08)'}`,overflow:'hidden',transition:'all 0.2s',boxShadow:isOpen?`0 0 0 1px ${color}22`:'none'}}>
                    <div onClick={()=>toggle(i)} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'14px 18px',cursor:'pointer',userSelect:'none'}}>
                      <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                        <div style={{width:'8px',height:'8px',borderRadius:'50%',background:isOpen?color:'rgba(255,255,255,0.2)',flexShrink:0,transition:'all 0.2s'}} />
                        <h3 style={{fontFamily:'DM Sans,sans-serif',fontSize:'14px',fontWeight:'700',color:isOpen?'#f1f5f9':'#cbd5e1',margin:0,transition:'color 0.2s'}}>
                          {sec.title}
                        </h3>
                      </div>
                      <div style={{width:'28px',height:'28px',borderRadius:'50%',background:isOpen?`${color}33`:'rgba(255,255,255,0.05)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,transition:'all 0.2s'}}>
                        <span style={{color:isOpen?color:'#475569',fontSize:'18px',lineHeight:'1',display:'block',transform:isOpen?'rotate(45deg)':'none',transition:'transform 0.2s',fontWeight:'300'}}>+</span>
                      </div>
                    </div>
                    {isOpen && (
                      <div style={{padding:'0 18px 18px 36px'}}>
                        <div style={{height:'1px',background:'rgba(255,255,255,0.06)',marginBottom:'14px'}} />
                        <div
                          style={{fontFamily:'Inter,sans-serif',fontSize:'15px',color:'#cbd5e1',lineHeight:'1.85',margin:0}}
                          dangerouslySetInnerHTML={{__html: globalStyle + '<div class="gc">' + sec.content + '</div>'}}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* CTA */}
            <div style={{marginTop:'28px',borderRadius:'16px',padding:'24px 28px',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'16px',background:`linear-gradient(135deg, ${currentMeta?.color||'#6366f1'}cc, ${currentMeta?.color||'#6366f1'}88)`,border:`1px solid ${currentMeta?.color||'#6366f1'}44`}}>
              <div>
                <h4 style={{fontFamily:'Manrope,sans-serif',fontSize:'16px',fontWeight:'700',color:'#fff',marginBottom:'5px'}}>
                  Need help applying for {guide.name}?
                </h4>
                <p style={{fontFamily:'Inter,sans-serif',fontSize:'13px',color:'rgba(255,255,255,0.8)',margin:0}}>
                  Our experts have helped 1,000+ students win fully funded scholarships 🎓
                </p>
              </div>
              <button
                onClick={() => setActivePage && setActivePage('experts')}
                style={{fontFamily:'Inter,sans-serif',fontSize:'14px',fontWeight:'700',background:'#fff',color:currentMeta?.color||'#6366f1',border:'none',padding:'12px 24px',borderRadius:'10px',cursor:'pointer',whiteSpace:'nowrap'}}
                onMouseEnter={e => e.currentTarget.style.opacity='0.9'}
                onMouseLeave={e => e.currentTarget.style.opacity='1'}
              >
                Meet Our Experts →
              </button>
            </div>

            <div style={{height:'40px'}} />
          </div>
        )}
      </div>
    </div>
  );
}